import { pluralize } from '~/utils/string'

const getUnits = (group, item, value) => {
  if (group?.overrideUnit) return ` ${group.overrideUnit}`
  if (group?.shouldShowUnit) return ` ${pluralize(item.unit, value)}`
  return ''
}

export const formatSwitch = (filters, group, value) => {
  const selectedItem = filters[group.objKey].find((item) => item.value == value)
  const selectedUnits = getUnits(group, selectedItem, value)

  switch (group?.type) {
    case 'dynamic':
      return selectedItem?.name + selectedUnits

    case 'range':
      return group.formatLabelFn(value.rangeFrom, value.rangeTo) + selectedUnits

    case 'standard':
    default:
      return group.formatLabelFn(value) + selectedUnits
  }
}
